import { createFileRoute } from '@tanstack/react-router';
import { HealthReportsScreen } from '../../screens/health/HealthReports';

export const Route = createFileRoute('/health/reports')({
  component: HealthReportsScreen,
});
